"use client"

import { Box, Typography, Card, CardContent, Grid, Button, Divider } from "@mui/material"

export default function SummaryStep({ data, onNext, onBack }) {
  const formatDate = (dateString) => {
    if (!dateString) return "Not specified"
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
  }

  console.log("data passed from previous step here...", data)

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Review Distribution Information
      </Typography>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Supplier
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {data.supplier || "Not specified"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Project
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {data.project || "Not specified"}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Date
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {formatDate(data.date)}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Distribution Stage
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {data.distributionStage || "Not specified"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
        <Button onClick={onBack} size="large">
          Back
        </Button>
        <Button variant="contained" onClick={onNext} size="large">
          Confirm
        </Button>
      </Box>
    </Box>
  )
}
